/* TITAN WALLS · Reading Room Mobile v6.2
   Manual touch flow only. No scripted movement of the document or reading rails. */
(() => {
  'use strict';

  if (window.__twReadingRoomMobileV6) return;
  window.__twReadingRoomMobileV6 = true;

  const MOBILE_QUERY = '(max-width: 749px)';
  const mq = window.matchMedia(MOBILE_QUERY);
  const initialized = new WeakSet();
  const nativeScrollIntoView = Element.prototype.scrollIntoView;

  const isReadingSample = () => document.body?.classList.contains('template-suffix-reading-sample');

  const isReadingElement = (element) => {
    if (!(element instanceof Element)) return false;
    return Boolean(
      element.closest('[data-reading-reader], [data-reading-hero]') ||
      element.id?.startsWith('reading-excerpt-')
    );
  };

  const activateHeroSelection = (selector) => {
    const hero = selector?.closest('[data-reading-hero]');
    if (!hero) return;

    const selectors = [...hero.querySelectorAll('[data-reading-hero-select]')];
    const sheets = [...hero.querySelectorAll('[data-reading-hero-sheet]')];
    const index = selectors.indexOf(selector);
    if (index < 0 || !sheets[index]) return;

    const activeSheet = sheets[index];
    const source = activeSheet.dataset.readingHeroSource || '';
    const title = activeSheet.dataset.readingHeroTitle || '';

    sheets.forEach((sheet, sheetIndex) => {
      const active = sheetIndex === index;
      sheet.classList.toggle('is-active', active);
      sheet.hidden = !active;
    });

    selectors.forEach((item, itemIndex) => {
      if (itemIndex === index) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });

    hero.querySelectorAll('[data-reading-hero-current]').forEach((node) => {
      node.textContent = String(index + 1).padStart(2, '0');
    });

    hero.querySelectorAll('[data-reading-hero-source]').forEach((node) => {
      if (!node.matches('[data-reading-hero-sheet]')) node.textContent = source;
    });

    hero.querySelectorAll('[data-reading-hero-title]').forEach((node) => {
      if (!node.matches('[data-reading-hero-sheet]')) node.textContent = title;
    });
  };

  const installScrollGuard = () => {
    if (window.__twReadingScrollGuardInstalled) return;
    window.__twReadingScrollGuardInstalled = true;

    Element.prototype.scrollIntoView = function guardedReadingScrollIntoView(...args) {
      if (mq.matches && isReadingSample() && isReadingElement(this)) return undefined;
      return nativeScrollIntoView.apply(this, args);
    };

    document.addEventListener('click', (event) => {
      if (!mq.matches || !isReadingSample() || !(event.target instanceof Element)) return;

      const trigger = event.target.closest(
        '[data-reading-open], [data-reading-jump], [data-reading-prev-page], [data-reading-next-page]'
      );
      if (!trigger) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (trigger.matches('[data-reading-hero-select]')) {
        activateHeroSelection(trigger);
      }
    }, true);
  };

  const installManualFlowStyles = () => {
    const existing = document.getElementById('tw-reading-manual-flow');
    if (!mq.matches) {
      existing?.remove();
      return;
    }
    if (existing) return;

    const style = document.createElement('style');
    style.id = 'tw-reading-manual-flow';
    style.textContent = `
      body.template-suffix-reading-sample #MainContent .tw-reading-hero__sequence,
      body.template-suffix-reading-sample #MainContent .tw-reading-reader__index,
      body.template-suffix-reading-sample #MainContent .tw-reading-curation__grid,
      body.template-suffix-reading-sample #MainContent .tw-reading-guide__steps,
      body.template-suffix-reading-sample #MainContent .tw-reading-excerpt__pages {
        scroll-behavior: auto !important;
        scroll-snap-type: none !important;
        scrollbar-width: thin !important;
        scrollbar-color: rgba(232, 237, 239, .42) rgba(232, 237, 239, .08) !important;
      }

      body.template-suffix-reading-sample #MainContent .tw-reading-hero__sequence::-webkit-scrollbar,
      body.template-suffix-reading-sample #MainContent .tw-reading-reader__index::-webkit-scrollbar,
      body.template-suffix-reading-sample #MainContent .tw-reading-curation__grid::-webkit-scrollbar,
      body.template-suffix-reading-sample #MainContent .tw-reading-guide__steps::-webkit-scrollbar,
      body.template-suffix-reading-sample #MainContent .tw-reading-excerpt__pages::-webkit-scrollbar {
        display: block !important;
        width: auto !important;
        height: 4px !important;
      }

      body.template-suffix-reading-sample #MainContent .tw-reading-hero__sequence::-webkit-scrollbar-track,
      body.template-suffix-reading-sample #MainContent .tw-reading-reader__index::-webkit-scrollbar-track,
      body.template-suffix-reading-sample #MainContent .tw-reading-curation__grid::-webkit-scrollbar-track,
      body.template-suffix-reading-sample #MainContent .tw-reading-guide__steps::-webkit-scrollbar-track,
      body.template-suffix-reading-sample #MainContent .tw-reading-excerpt__pages::-webkit-scrollbar-track {
        background: rgba(232, 237, 239, .08) !important;
      }

      body.template-suffix-reading-sample #MainContent .tw-reading-hero__sequence::-webkit-scrollbar-thumb,
      body.template-suffix-reading-sample #MainContent .tw-reading-reader__index::-webkit-scrollbar-thumb,
      body.template-suffix-reading-sample #MainContent .tw-reading-curation__grid::-webkit-scrollbar-thumb,
      body.template-suffix-reading-sample #MainContent .tw-reading-guide__steps::-webkit-scrollbar-thumb,
      body.template-suffix-reading-sample #MainContent .tw-reading-excerpt__pages::-webkit-scrollbar-thumb {
        border-radius: 999px !important;
        background: rgba(232, 237, 239, .42) !important;
      }

      body.template-suffix-reading-sample #MainContent .tw-reading-hero__sequence a,
      body.template-suffix-reading-sample #MainContent .tw-reading-reader__index li,
      body.template-suffix-reading-sample #MainContent .tw-reading-page,
      body.template-suffix-reading-sample #MainContent .tw-reading-lens,
      body.template-suffix-reading-sample #MainContent .tw-reading-guide__step {
        scroll-snap-align: none !important;
        scroll-snap-stop: normal !important;
      }

      body.template-suffix-reading-sample #MainContent .tw-reading-reader__status-actions,
      body.template-suffix-reading-sample #MainContent .tw-reading-hero__entry {
        display: none !important;
      }

      body.template-suffix-reading-sample #MainContent .tw-reading-reader__status {
        grid-template-columns: 42px minmax(0, 1fr) !important;
      }

      body.template-suffix-reading-sample #MainContent .tw-reading-reader__index a,
      body.template-suffix-reading-sample #MainContent .tw-reading-hero__sheet {
        pointer-events: none !important;
      }

      body.template-suffix-reading-sample #MainContent .tw-reading-hero__sequence a {
        touch-action: pan-x pan-y !important;
      }

      @media (max-width: 420px) {
        body.template-suffix-reading-sample #MainContent .tw-reading-reader__status {
          grid-template-columns: 38px minmax(0, 1fr) !important;
        }
      }
    `;
    document.head.append(style);
  };

  const enhanceRail = (rail, label) => {
    if (!rail || initialized.has(rail)) return;
    initialized.add(rail);
    rail.setAttribute('role', rail.getAttribute('role') || 'region');
    if (!rail.getAttribute('aria-label')) rail.setAttribute('aria-label', label);
    rail.dataset.touchRail = 'true';
  };

  const bindViewerSwipe = (viewer) => {
    if (!viewer || initialized.has(viewer)) return;
    initialized.add(viewer);

    const stage = viewer.querySelector('.tw-reading-viewer__stage');
    const previous = viewer.querySelector('[data-reading-viewer-prev]');
    const next = viewer.querySelector('[data-reading-viewer-next]');
    if (!stage || !previous || !next) return;

    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startedAt = 0;

    const reset = () => {
      pointerId = null;
      startX = 0;
      startY = 0;
      startedAt = 0;
      stage.classList.remove('is-swipe-tracking');
    };

    stage.addEventListener('pointerdown', (event) => {
      if (!mq.matches || event.pointerType === 'mouse') return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startedAt = performance.now();
      stage.classList.add('is-swipe-tracking');
    }, { passive: true });

    stage.addEventListener('pointerup', (event) => {
      if (pointerId !== event.pointerId) return;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      const elapsed = performance.now() - startedAt;
      const horizontal = Math.abs(deltaX) > Math.abs(deltaY) * 1.25;
      const intentional = Math.abs(deltaX) >= 48 && elapsed <= 700;

      if (horizontal && intentional) {
        if (deltaX < 0 && !next.disabled) next.click();
        if (deltaX > 0 && !previous.disabled) previous.click();
      }

      reset();
    }, { passive: true });

    stage.addEventListener('pointercancel', reset, { passive: true });
  };

  const enhance = () => {
    document.documentElement.classList.toggle('tw-reading-mobile', mq.matches);
    installManualFlowStyles();

    document.querySelectorAll('.tw-reading-hero__sequence').forEach((rail) => {
      enhanceRail(rail, 'Originalauszüge. Frei horizontal wischen, um weitere Akten anzuzeigen.');
    });

    document.querySelectorAll('.tw-reading-reader__index').forEach((rail) => {
      enhanceRail(rail, 'Originalakten. Frei horizontal wischen, ohne automatischen Sprung.');
    });

    document.querySelectorAll('.tw-reading-curation__grid').forEach((rail) => {
      enhanceRail(rail, 'Leselinsen. Frei horizontal wischen, um weitere Prüfkarten anzuzeigen.');
    });

    document.querySelectorAll('.tw-reading-guide__steps').forEach((rail) => {
      enhanceRail(rail, 'Leseprotokoll. Frei horizontal wischen, um weitere Prüfschritte anzuzeigen.');
    });

    document.querySelectorAll('.tw-reading-excerpt__pages').forEach((rail) => {
      enhanceRail(rail, 'Originalseiten. Frei horizontal zwischen den Seiten dieser Akte wischen.');
    });

    document.querySelectorAll('[data-reading-viewer]').forEach(bindViewerSwipe);
  };

  installScrollGuard();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  mq.addEventListener?.('change', enhance);
  document.addEventListener('shopify:section:load', enhance);
})();